export interface IMedicationList {
  ocorrenciaNo: number;
	tipoMaterial:  string;
	codigo:  any;
	titulo:  any;
	habilitado:  boolean;
	quantidadeEmbalagem:  any;
    }

